export const ApiFacilityRoles = {
  All: "Facility.All"
};

export const ApiUserRoles = {
  SuperAdmin: "Role.SuperAdmin",
  Office: "Role.Office"
};
